import React from 'react';
import CourseCard from '../CourseCard';
import { courses } from '../../data/courses';

const Courses = ({ onCourseClick }) => {
  return (
    <section className="courses" id="courses">
      <div className="container">
        <div className="courses-header" data-reveal>
          <span className="section-eyebrow">Programs</span>
          <h2 className="section-title">Career-Focused Courses</h2>
          <p className="section-subtitle">
            Structured paths built with industry engineers. Click any course to explore the full curriculum.
          </p>
        </div>
        <div className="courses-grid" data-reveal>
          {courses.map((course, index) => (
            <CourseCard
              key={course.title}
              course={course}
              index={index}
              onClick={() => onCourseClick && onCourseClick(course)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Courses;
